import React from 'react';

import { RoundedStarFilled } from '@depop/web-thrift-ui/Icons/RoundedStarFilled';
import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { DownloadAppQRCode } from '@/components/DownloadAppQRCode';

const OFFER_SENT_QR_SIZE = 112;

export function DownloadTheAppBadgeDesktop() {
  const t = useTranslations('common');

  return (
    <aside className={styles.appDownloadBadge}>
      <DownloadAppQRCode
        size={OFFER_SENT_QR_SIZE}
        withDepopLogo
        placement="make_offer"
      />
      <div className={styles.appDownloadBadgeText}>
        <Caption
          className={styles.appDownloadBadgeTitle}
          variant="lg-bold"
          colour="base"
        >
          {t('DownloadTheAppBadge.Title')}
        </Caption>
        <Caption className={styles.appDownloadBadgeBody} colour="base">
          {t('DownloadTheAppBadge.Body')}
        </Caption>
        <div
          className={styles.reviewsWrapper}
          role="img"
          aria-label="5 out of 5 stars based on 521k reviews"
        >
          {Array.from({ length: 5 }, (_, i) => (
            <RoundedStarFilled key={i} size="sm" aria-hidden />
          ))}
          <Caption
            className={styles.reviewsText}
            variant="sm-regular"
            aria-hidden
          >
            (521k)
          </Caption>
        </div>
      </div>
    </aside>
  );
}
